import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/pages/NotFound.css';

/**
 * NotFound component that displays a 404 error page.
 * 
 * @returns {React.ReactNode} - The 404 error page
 */
const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for does not exist or you don't have permission to access it.</p>
        <Link to="/" className="home-button">
          Go to Home Page
        </Link>
      </div>
    </div>
  );
};

export default NotFound;